import styled from 'styled-components'

export const ScreenshotModal = ({ onClose }) => (
  <ModalOverlay onClick={onClose}>
    <ModalContent onClick={(e) => e.stopPropagation()}>
      <h2 style={{ color: '#fff', marginBottom: '12px' }}>⚠️ Screenshot Detected</h2>
      <p style={{ color: '#ddd', marginBottom: '20px' }}>
        This content is for authorized, paying users only. Capturing, recording, or sharing it — including via screenshots — is strictly prohibited and violates our Terms of Service. Unauthorized use may result in account suspension or legal action.
      </p>
      <button
        onClick={onClose}
        style={{
          background: '#fff',
          color: '#000',
          padding: '10px 20px',
          borderRadius: '8px',
          cursor: 'pointer',
          fontWeight: 'bold'
        }}
      >
        Got it
      </button>
    </ModalContent>
  </ModalOverlay>
)

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  background: #111;
  padding: 24px;
  border-radius: 12px;
  max-width: 90%;
  max-height: 90%;
  text-align: center;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.6);
`;
